import { Component, OnInit } from '@angular/core';
import { CybersocxdrService } from 'src/app/shared/services/xtendedsoc/cybersocxdr.service';
import { LocalStorageItem } from 'src/app/shared/model/shared-items';
import { UserClaims } from '@okta/okta-auth-js';
import { DefaultLayoutComponent } from '../default-layout/default-layout.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { ContextService } from 'src/app/shared/services/context-service';

interface UserObj extends UserClaims {groups: string[]};

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: [
    './layout.component.scss',
    './../default-layout/default-layout.component.scss'
  ]
})
export class LayoutComponent extends DefaultLayoutComponent implements OnInit {

  comproles: string[] = [];
  userAdmin = false;
  compMicroSOCXDR = false;
  changeTenants = false;
  tenantNameAdmin: string;
  pageAnalyticsAccess = false;

  //Modal
  closeResult: string;

  //Label
  public logoutLabel: string;

  //layout
  public isDashboard: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cybersocxdrService: CybersocxdrService,
    public contextService: ContextService,
  ) {
    super();
    this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    )
    .subscribe(event => {
      this.contextService.title = event.title;
      this.contextService.subtitle =  event.subtitle;
      this.contextService.image = event.image;
      this.contextService.alt = event.alt;
      this.contextService.fullWidth = !!event.fullWidth;
      this.contextService.isDashboard = event.title === 'dashboard' ? true : false
    });
  }

  ngOnInit(): void {
    this.loadUserDetails();
  }

  public onActivate(event) {
    window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
     });
 }


  private loadUserDetails(): void {
    this.contextService.getUserDetails().then((val: UserObj) => {
      // check to see if multiple tenants are available, and if one has been selected
      let tenants = JSON.parse(
        localStorage.getItem(LocalStorageItem.oktaTenants)
      );
      // if the user is an admin, and can see multiple tenants then enable the change tenants feature
      if (tenants && tenants.availableTenants.length > 1) {
        // allow the changing of tenants
        this.changeTenants = true;
      }
      this.userObject = val;
      this.setUserAdmin();
      this.setCompRoles();
      this.pageAnalyticsAccess = this.userObject.groups.some(g => g.endsWith('_Access_Page_Analytics'));
    });
  }

  private setUserAdmin(): void {
    if (
      this.userObject.groups.filter((g) => g.startsWith('ADMINS_')).length > 0
    ) {
      this.tenantNameAdmin = this.userObject.groups
        .filter((g) => g.startsWith('ADMINS_'))[0]
        .split('_')[1];
      // check to see if multiple tenants are available, and if one has been selected
      const tenants = JSON.parse(
        localStorage.getItem(LocalStorageItem.oktaTenants)
      );
      // if the user is an admin, and can see multiple tenants then enable the change tenants feature
      if (tenants && tenants.availableTenants.length > 1) {
        // if the user is an admin of the selected tenant then allow the admin menu item
        if (
          tenants.selectedTenant &&
          tenants.selectedTenant === this.tenantNameAdmin
        ) {
          this.userAdmin = true;
        }
      } else {
        // if the user is an admin but is only a user for one tenant then allow it
        this.userAdmin = true;
      }
    } else {
      // if the user is not an admin
      this.userAdmin = false;
    }
  }

  private setCompRoles(): void {
    if (this.userObject.groups.filter(g =>  g.startsWith('COMPROLE_')).length > 0){
      const allComproles = this.userObject.groups.filter(g => g.startsWith('COMPROLE_'));
      for (const fullComprole of allComproles) {
        const comprole = fullComprole.split('_')[2];
        if (comprole === 'MicroSOCXDR') {
          this.cybersocxdrService.isMicrosocXDRosmClient().then(result => {
            this.compMicroSOCXDR = result;
          });
        }
        this.comproles.push(comprole);
      }
    }
  }

}
